<template>
  <StepTwoDialog ref="dialog" openBtnName="修改" @input="handleAcceptStep" @before-close="handleFinish"  @closed="handleDialogClose">
    <div slot="title" class="cc-title">登录账号修改</div>
    <el-form :model="form" ref="form" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="登录账号" prop="userAccount">
        <el-row>
          <el-col>
          <el-input
            v-noSpace
            placeholder="8-20个字符,由字母、数字组成"
            v-model.trim="form.userAccount">
          </el-input>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </StepTwoDialog>
</template>

<script>
import StepTwoDialog from './StepTwoDialog'
export default {
  components: {
    StepTwoDialog
  },
  data() {
    var validateUserAccount = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入登录账号'))
      } else {
        if (/^[A-Za-z]+$/g.test(value)) {
          this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then(data => {
            if (data.isError) {
              callback(new Error('该登录账号已被占用，请重新输入'))
            } else {
              callback()
            }
          })
        } else {
          if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value)) {
            this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then(data => {
              if (data.isError) {
                callback(new Error('该登录账号已被占用，请重新输入'))
              } else {
                callback()
              }
            })
          } else {
            callback(new Error('登录账号为8-20个字符，需含英文字母'))
          }
        }
      }
    }
    return {
      activeStep: 0,
      form: {
        userAccount: undefined
      },
      rules: {
        userAccount: [
          { validator: validateUserAccount, trigger: 'blur' }
        ]
      }

    }
  },
  computed: {

  },
  methods: {
    handleAcceptStep(val) {
      this.activeStep = val
    },
    handleFinish() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$service.updateAgentAccount({ agentAccount: this.$encrypt(this.form.userAccount) }, '修改成功')
            .then(() => {
              this.$refs.dialog.isVisableDialog = false
              setTimeout(() => {
                this.$alert('登录账号已更换，将返回登录界面重新登录', '', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$service.logout()
                    this.$router.push({ name: 'login' })
                  }
                })
              }, 500)
            })
        }
      })
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
      this.$refs.dialog.isVisableDialog = false
    }
  },
  created() {

  }
}
</script>

<style lang="stylus" scoped>
// .dialog-form--wrapper
  // margin 30px 60px 0
// .dialog-form--wrapper >>> .el-form-item
//   margin-bottom 24px
.cc-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
>>>.el-dialog__body
  padding 0
.demo-ruleForm
  max-width 500px
.demo-ruleForm >>>.el-form-item
  margin-bottom 15px
</style>
